import { render, staticRenderFns } from "./FittingsInventoryBalance.vue?vue&type=template&id=f4942424&scoped=true"
import script from "./FittingsInventoryBalance.vue?vue&type=script&lang=js"
export * from "./FittingsInventoryBalance.vue?vue&type=script&lang=js"
import style0 from "./FittingsInventoryBalance.vue?vue&type=style&index=0&id=f4942424&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4942424",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4942424')) {
      api.createRecord('f4942424', component.options)
    } else {
      api.reload('f4942424', component.options)
    }
    module.hot.accept("./FittingsInventoryBalance.vue?vue&type=template&id=f4942424&scoped=true", function () {
      api.rerender('f4942424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Fittings/FittingsInventoryBalance/FittingsInventoryBalance.vue"
export default component.exports